exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".noPadding{padding-left:0; padding-right:0;}\n@media(max-width:767px){\n .inputBoxWrapper button.btn-ylw{width: 100% !important;}\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/student-calculator/student-calculator.component.css
// module id = ../../../../../src/app/pages/student-calculator/student-calculator.component.css
// module chunks = main